import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Force English digits globally for all number and date formatting
const origNumberToLocaleString = Number.prototype.toLocaleString;
Number.prototype.toLocaleString = function (locales?: any, options?: any) {
  return origNumberToLocaleString.call(this, 'en-US', options);
};

const origDateToLocaleString = Date.prototype.toLocaleString;
Date.prototype.toLocaleString = function (locales?: any, options?: any) {
  // If dateStyle/timeStyle used, force en-US with ISO-like date
  if (options?.dateStyle || options?.timeStyle) {
    const parts: string[] = [];
    const y = this.getFullYear();
    const m = String(this.getMonth() + 1).padStart(2, '0');
    const d = String(this.getDate()).padStart(2, '0');
    parts.push(`${y}-${m}-${d}`);
    if (options?.timeStyle) {
      const h = String(this.getHours()).padStart(2, '0');
      const min = String(this.getMinutes()).padStart(2, '0');
      parts.push(`${h}:${min}`);
    }
    return parts.join(' ');
  }
  return origDateToLocaleString.call(this, 'en-US', options);
};

const origDateToLocaleDateString = Date.prototype.toLocaleDateString;
Date.prototype.toLocaleDateString = function (_locales?: any, _options?: any) {
  const y = this.getFullYear();
  const m = String(this.getMonth() + 1).padStart(2, '0');
  const d = String(this.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// Auto-update: detect a newer deployed build via /version.json and reload
// transparently. Also keeps the SW in sync (skipWaiting + controllerchange).
import { initVersionCheck } from "./lib/versionCheck";

if ("serviceWorker" in navigator) {
  let reloadingForUpdate = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadingForUpdate) return;
    reloadingForUpdate = true;
    window.location.reload();
  });
}

initVersionCheck();

createRoot(document.getElementById("root")!).render(<App />);
